import { CellState, PlayerInfo } from '../types';

/**
 * Represents a player in the game
 */
export class Player implements PlayerInfo {
  readonly name: string;
  readonly mark: CellState.PLAYER_X | CellState.PLAYER_O;

  constructor(name: string, mark: CellState.PLAYER_X | CellState.PLAYER_O) {
    this.name = name;
    this.mark = mark;
  }

  /**
   * Returns a string representation of the player
   */
  toString(): string {
    return `${this.name} (${this.mark})`;
  }
}
